<template>
  <Modal
    title="Departments with Financing Available"
    class-name="small-modal"
    :saving="saving"
    @hide-modal="emit('hide-modal')"
    @submit="handleSubmit"
  >
    <div>
      <Select
        v-model="departmentIds"
        label="Select Departments:"
        :options="departmentOptions"
        :multiple="true"
        :search="true"
        :placeholder="'All (Default)'"
      >
        <template #item-row="{ option }">
          <div class="option-row">
            <span :class="{ 'strike-through': option.archived }">
              {{ option.label }}
            </span>
          </div>
        </template>
      </Select>
      <div class="note" :class="{ note__hidden: noSelection }">
        Note: You can enable all departments by clearing your selection.
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import Modal from "@/components/Modal.vue";

const props = defineProps({
  departmentOptions: {
    type: Array,
    required: true
  },
  activeDepartmentIds: {
    type: Array,
    default: () => []
  }
});

const departmentIds = ref(props.activeDepartmentIds);
const saving = ref(false);

const noSelection = computed(() => {
  return (departmentIds.value || []).length === 0;
});

const emit = defineEmits(["hide-modal", "submit"]);

function handleSubmit() {
  saving.value = true;
  emit("submit", departmentIds.value || []);
}
</script>

<style scoped lang="scss">
.note {
  color: var(--neutral-gray-700);
  font-size: 12px;
  margin-top: 4px;
  margin-left: 4px;

  &__hidden {
    visibility: hidden;
  }
}
</style>
